export default __webpack_public_path__ + "static/ype2-e5facbf6b98a4444a45ca7b8e0972bcf.jpg";